module.exports = __webpack_public_path__ + "img/tfc2.c8586b4a.png";